// extracted by mini-css-extract-plugin
export default {"root":"DataListItemTrialOnboard__root--2EvOo","image":"DataListItemTrialOnboard__image--1JmeL"};